import { useCallback, type ChangeEvent } from "react";

import type { Editor } from "@tiptap/react";

type Props = {
	editor: Editor;
	uploadImage: (file: File) => Promise<string>;
};

export const useEditorMenu = ({ editor, uploadImage }: Props) => {
	const isSelectedTitle = editor.isActive("heading", { level: 3 }) ?? false;
	const handleTitle = useCallback(() => {
		editor.chain().focus().toggleHeading({ level: 3 }).run();
	}, [editor]);

	const isSelectedBold = editor.isActive("bold") ?? false;
	const handleBold = useCallback(() => {
		editor.chain().focus().toggleBold().run();
	}, [editor]);

	const isSelectedItalic = editor.isActive("italic") ?? false;
	const handleItalic = useCallback(() => {
		editor.chain().focus().toggleItalic().run();
	}, [editor]);

	const isSelectedQuote = editor.isActive("blockquote") ?? false;
	const handleQuote = useCallback(() => {
		editor.chain().focus().toggleBlockquote().run();
	}, [editor]);

	const isSelectedSubtitles = editor.isActive("heading", { level: 6 }) ?? false;
	const handleSubtitles = useCallback(() => {
		editor.chain().focus().toggleHeading({ level: 6 }).run();
	}, [editor]);

	const handleImage = async (event: ChangeEvent<HTMLInputElement>) => {
		await uploadImage(event.target.files![0]).then((src) => {
			editor.chain().focus().setImage({ src }).run();
			editor.chain().focus().toggleHeading({ level: 6 }).run();
		});
	};

	return {
		isSelectedTitle,
		handleTitle,

		isSelectedBold,
		handleBold,

		isSelectedItalic,
		handleItalic,

		isSelectedQuote,
		handleQuote,

		isSelectedSubtitles,
		handleSubtitles,

		handleImage,
	};
};
